import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, type SxProps, type Theme } from '@mui/material';
import { useToggle } from '/@/hooks/toggle/useToggle';
import { _ } from '/@/locale';
import useIsMobile from '/@/utils/hooks/is-mobile';
import Title from '/@/v3/components/title';
import NewItemOverlay from '../map/new-item-overlay';

const cardSx: SxProps<Theme> = {
    background: 'white',
    borderRadius: '10px',
    boxShadow: '-20px 10px 20px 0px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
};

const IncidenceMapsOverlayReferences = ({ overlay, version, onOverlayChange, sx }) => {
    const isMobile = useIsMobile();
    const { open, toggle } = useToggle();
    const isOpenedOnMobile = open || !isMobile;

    return (
        <Box sx={[{ ...cardSx, ...sx }, !open ? { margin: '12px', width: { xs: 200, md: 350 } } : { height: '100%' }]}>
            <Box
                sx={[
                    {
                        borderBottom: '1px lightgray solid',
                        p: 2,
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    },
                    !isOpenedOnMobile && {
                        border: 'none',
                    },
                ]}
                onClick={() => toggle()}
            >
                <Title size='md' bolder>
                    <Box sx={[{ display: 'flex', gap: 2, p: 0, alignItems: 'center' }]}>
                        <span>{_('Referencias')}</span>
                    </Box>
                </Title>
                <KeyboardArrowDownIcon
                    sx={[
                        { display: { md: 'none' }, pointer: 'cursor', pointerEvents: 'all' },
                        !isOpenedOnMobile && {
                            transform: 'rotate(180deg)',
                        },
                    ]}
                />
            </Box>
            <Box
                sx={[
                    { display: 'flex', flexDirection: 'column', width: '100%', height: '100%', overflow: 'scroll' },
                    !isOpenedOnMobile && { display: 'none' },
                ]}
            >
                {isOpenedOnMobile && (
                    <>
                        <NewItemOverlay
                            overlay={overlay}
                            version={version}
                            onOverlayChange={onOverlayChange}
                            expanded
                        />
                    </>
                )}
            </Box>
        </Box>
    );
};

export default IncidenceMapsOverlayReferences;
